import { Factory } from "@/data/dao/Factory";
import { SystemDao } from "@/data/dao/service/SystemDao";
import { TaskSuccessState } from "@/data/model/Enums";
import type { IRecurringTask, ITaskExecution } from "@/data/model/RecurringTask";

import { i18n } from "@/portal/Trans";
import { BaseTabbedController } from "@/portal/controller/BaseTabbedController";
import { DataTable, type IDataTableConfig } from "@/portal/elements/DataTable";
import { TaskForm } from "@/portal/forms/TaskForm";
import { PortalDateTime } from "@/portal/util/PortalDateTime";

export class TaskController extends BaseTabbedController<IRecurringTask> {
    private taskForm: TaskForm;
    private executionTable?: DataTable<ITaskExecution>;

    constructor(element: JQuery) {
        super(element, Factory.getInstance<SystemDao>(SystemDao).taskDataSource);

        this.taskForm = new TaskForm(this.formContentByTabName("taskedit"));
        this.registerModelForm(this.taskForm);

        this.onActivateTab = (newTab) => {
            if (newTab === "taskexecution") this.showTaskExecutions();
        };
    }

    protected onModelLoaded(m?: IRecurringTask) {
        if (m === undefined) this.disableTabs(["taskexecution"]);
        else this.enableTabs(["taskexecution"]);

        this.taskForm.setData(m);
    }

    private showTaskExecutions() {
        if (this.executionTable === undefined) {
            const tableConfig: IDataTableConfig<ITaskExecution> = {
                columnMapping: [
                    {
                        name: i18n("general.fields.state"),
                        property: "state",
                        styles: { width: "12%" },
                        formatter: (m, p) => {
                            let styleClass = "";
                            switch (p) {
                                case TaskSuccessState.Success:
                                    styleClass = "kt-badge--success";
                                    break;
                                case TaskSuccessState.Failed:
                                    styleClass = "kt-badge--danger";
                                    break;
                            }

                            return (
                                '<div class="kt-badge ' +
                                styleClass +
                                ' kt-badge--inline">' +
                                i18n("enums.TaskSuccessState." + TaskSuccessState[p]) +
                                "</div>"
                            );
                        },
                    },
                    {
                        name: i18n("task.fields.started"),
                        property: "start",
                        styles: { width: "12%" },
                        formatter: (m, p) => PortalDateTime.toRelativeString(p),
                    },
                    {
                        name: i18n("task.fields.duration"),
                        property: "end",
                        styles: { width: "12%" },
                        formatter: (m) => {
                            const dif = Math.round((m.end.getTime() - m.start.getTime()) / 1000);
                            return dif + " Sekunden";
                        },
                    },
                    {
                        name: i18n("task.fields.result"),
                        property: "message",
                        styles: { width: "64%" },
                    },
                ],
                defaultSortAsc: false,
                defaultSortProperty: "start",
            };

            this.executionTable = new DataTable<ITaskExecution>(
                this.formContentByTabName("taskexecution").find("> .kt-portlet__body > .kt-datatable"),
                Factory.getInstance<SystemDao>(SystemDao).getTaskExecutionDataSource(this.entityId!),
                tableConfig
            );
        } else this.executionTable.loadData();
    }
}
